import {Injectable} from '@angular/core';
import {VerifyApi} from '../api/verify.api';
import {CplCycle} from '../model/cpl-cycle.model';
import {UserVerification} from '../model/cycle-verification.model';

@Injectable()
export class VerifyService {
    constructor(private verifyApi: VerifyApi) {}

    verify = (cycleVerification: UserVerification[]) => this.verifyApi.verify(cycleVerification);

    submitForVerification = (userCycle: CplCycle) => this.verifyApi.submitForVerification(userCycle);

    getVerifyHistoryForSupervisors = (userCycleId: string) => this.verifyApi.getVerifyHistoryForSupervisors(userCycleId);

    getVerifyHistoryForEndUser = (userCycleId: string) => this.verifyApi.getVerifyHistoryForEndUser(userCycleId);
}